import { createRestClient, ApiError } from "@marekl/adminer/api";
import { clearMe } from "@marekl/adminer";
import { queryClient } from "./queryClient";

// Reads the runtime config injected by the Go server into index.html.
// The global name stays __KARTIS_CONFIG__ to match the backend injection.
const client = createRestClient({
  baseUrl: window.__KARTIS_CONFIG__?.apiBaseURL ?? "/api",
  csrfCookieName: "adminer_csrf",
  // A mid-session 401 on any data call clears the cached user; RequireAuth
  // then redirects to /login.
  onUnauthorized: () => clearMe(queryClient),
});

export { ApiError };
export const apiGet = client.get;
export const apiPost = client.post;
export const apiPut = client.put;
export const apiPatch = client.patch;
export const apiDelete = client.delete;
